import dayjs from 'dayjs';

export const humanizeMinutes = (mins: number) => {
  const m = Math.abs(mins);
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h > 0) return `${h} giờ ${mm} phút`;
  return `${mm} phút`;
};

export const calcCountdownProgress = (
  receptionDate?: string | null,
  expectedDate?: string | null,
  actualDate?: string | null
) => {
  if (!receptionDate || !expectedDate) return { percent: 0, label: '', color: '#d9d9d9' };

  const start = dayjs(receptionDate);
  const expected = dayjs(expectedDate);
  const actual = actualDate ? dayjs(actualDate) : null;
  const now = dayjs();

  const totalMinutes = expected.diff(start, 'minute');
  if (totalMinutes <= 0) return { percent: 0, label: '', color: '#d9d9d9' };

  // Nếu đã hoàn thành
  if (actual) {
    const usedMinutes = actual.diff(start, 'minute');
    const remainingMinutes = Math.max(totalMinutes - usedMinutes, 0);
    const percent = Math.round((remainingMinutes / totalMinutes) * 100);
    return {
      percent,
      label: `Hoàn thành: ${actual.format('HH:mm DD/MM')}`,
      color: '#02D8A0'
    };
  }

  // Nếu chưa hoàn thành
  const remainingMinutes = expected.diff(now, 'minute');
  if (remainingMinutes <= 0) {
    return {
      percent: -100,
      label: `ĐÃ QUÁ HẠN: ${humanizeMinutes(now.diff(expected, 'minute'))}`,
      color: '#D1131D'
    };
  }

  const percent = Math.round((remainingMinutes / totalMinutes) * 100);
  const color = percent > 70 ? '#02D8A0' : percent > 40 ? '#FF9500' : '#D1131D';

  return {
    percent,
    label: `Dự kiến còn ${humanizeMinutes(remainingMinutes)}`,
    color
  };
};
